


/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useRef, useState } from "react";
import { NumericFormat } from "react-number-format";

import { FormControl, FormLabel, Box } from "@chakra-ui/react";

import "./style.scss";

const CurrencyInputAlternateNoFormik = ({
  disabledInput,
  labelName,
  input,
  center,
  readOnly,
  removeBorder,
  inputRef,
  onBlur,
  allowNegative = true,
  prefix = "R$ ",
  suffix,
  onFocus,
  className,
  handleInputChange,
  index,
  forceUpdateValue,
}) => {
  const myInputRef = useRef(null);
  const [value, setValue] = useState(input);
  const programmaticUpdateRef = useRef(false);
  useEffect(() => {
    setValue(input);
  }, [input]);

  useEffect(() => {
    setValue(input);
  }, [input]);

  const clearFormatting = (val) => {
    let inputValue = parseFloat(val.replace("R$ ", "").replaceAll(".", "").replaceAll(",", "."));

    if (inputValue === null || inputValue === undefined || isNaN(inputValue)) inputValue = 0;

    return inputValue;
  };

  function handleFocusOnLastIndex(e) {
    if (onFocus && typeof onFocus == "function") onFocus(e);

    const length = myInputRef.current.value.length;
    if (myInputRef.current.setSelectionRange) {
      myInputRef.current.setSelectionRange(length, length);
    }
  }

  const handleKeyDown = (e) => {
    const val = myInputRef.current.value;

    let { key, keyCode } = e;

    if (keyCode === 229) {
      e.preventDefault();

      let newVal = clearFormatting(val);

      if (String(newVal).includes("-"))
        newVal = parseFloat(String(newVal).replace("-", ""));
      else newVal = parseFloat(`-${newVal}`);

      setValue(newVal);

      setTimeout(() => {
        handleFocusOnLastIndex();
      }, 1);
    }

    if (!isNaN(parseInt(key))) {
      e.preventDefault();

      const newVal = clearFormatting(val);

      let [inteiro, decimal] = String(newVal).split(".");
      const isNegativeZero = Object.is(newVal, -0);

      const firstOfDecimal = decimal?.[0] || 0;
      inteiro += firstOfDecimal;

      decimal = (decimal?.[1] || 0) + key;

      const parsedValue = parseFloat(`${isNegativeZero ? "-" : ""}${inteiro}.${decimal}`);

      setValue(parsedValue);

      setTimeout(() => {
        handleFocusOnLastIndex();
      }, 1);
    }
  };

  useEffect(() => {
    if (forceUpdateValue !== undefined) {
      programmaticUpdateRef.current = true;
      setValue(forceUpdateValue);
    }
  }, [forceUpdateValue]);

  return (
    <FormControl>
      {labelName && <FormLabel className="field__label">{labelName}</FormLabel>}
      <Box position="relative">
        <NumericFormat
          className={`currency-input-alternate search-wrapper searchWrapper currencyInput text-[1rem] ${disabledInput ? "opacity-25" : ""} ${
            center && "text-center"
          } ${removeBorder && "remove-border"}`}
          prefix={prefix}
          suffix={suffix}
          decimalScale={2}
          decimalSeparator=","
          thousandSeparator="."
          fixedDecimalScale
          allowNegative={allowNegative}
          onFocus={handleFocusOnLastIndex}
          value={value}
          onKeyDown={handleKeyDown}
          onValueChange={(values) => {
            const newValue = values.floatValue ?? 0;

            if (input !== newValue) {
              setValue(newValue);
            }
            handleInputChange(index, newValue);
            if (programmaticUpdateRef.current) {
              programmaticUpdateRef.current = false;
              return;
            }
          }}
          readOnly={readOnly}
          getInputRef={myInputRef}
          ref={inputRef}
          onBlur={onBlur}
          disabled={disabledInput ? true : false}
        />
      </Box>
    </FormControl>
  );
};

export default CurrencyInputAlternateNoFormik;